import {ValueObject} from '@s-ui/domain'

export class FaqsInfoValueObject extends ValueObject {
  #title
  #faqs
  #seoFaqs

  /**
   * @param {Object} deps
   * @param {FaqsValueObject} deps.faqs
   * @param {StructuredDataValueObject} deps.seoFaqs
   * @param {string} deps.title
   **/
  constructor({faqs, seoFaqs, title}) {
    super()
    this.#faqs = faqs
    this.#seoFaqs = seoFaqs
    this.#title = title
  }

  get faqs() {
    return this.#faqs
  }

  get seoFaqs() {
    return this.#seoFaqs
  }

  get title() {
    return this.#title
  }

  toJSON() {
    return {
      faqs: this.#faqs?.toJSON ? this.#faqs.toJSON() : this.#faqs,
      seoFaqs: this.#seoFaqs?.toJSON ? this.#seoFaqs.toJSON() : this.#seoFaqs,
      title: this.#title
    }
  }
}
